export default "__VITE_ASSET__CbfpzKNZ__"